var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoOperationLimits = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_operator_limits",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10752",
    "data-name": "Rectangle 10752",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_operator-limits",
    transform: "translate(3 -31.146)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48676",
    "data-name": "Path 48676",
    d: "M91.43,35.161a9.216,9.216,0,0,0-5.757,2.459l2.564,2.564a5.57,5.57,0,0,1,3.193-1.4Z",
    transform: "translate(-82.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48677",
    "data-name": "Path 48677",
    d: "M5.043,123.286l-2.564-2.564a9.738,9.738,0,0,0-2.468,5.95H3.637A6.146,6.146,0,0,1,5.043,123.286Z",
    transform: "translate(-.011 -82.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48678",
    "data-name": "Path 48678",
    d: "M382.017,126.672h3.626a9.737,9.737,0,0,0-2.468-5.95l-2.564,2.564A6.146,6.146,0,0,1,382.017,126.672Z",
    transform: "translate(-367.644 -82.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48679",
    "data-name": "Path 48679",
    d: "M401.091,306.227a5.2,5.2,0,0,1-.62,2.043c.291.449.534.829.695,1.081a1.726,1.726,0,0,1-.708,2.48l.6.6a.576.576,0,0,0,.814,0,9.32,9.32,0,0,0,2.85-6.2Z",
    transform: "translate(-386.73 -261.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48680",
    "data-name": "Path 48680",
    d: "M3.659,306.253H.031a9.237,9.237,0,0,0,2.83,6.175.576.576,0,0,0,.814,0l1.743-1.743a.576.576,0,0,0,0-.814,5.508,5.508,0,0,1-1.76-3.618Z",
    transform: "translate(0 -261.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48681",
    "data-name": "Path 48681",
    d: "M276.95,37.619a9.3,9.3,0,0,0-5.782-2.473v3.626a5.66,5.66,0,0,1,3.218,1.41Z",
    transform: "translate(-261.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48682",
    "data-name": "Path 48682",
    d: "M211.972,244.722a1.805,1.805,0,1,0-2.553,2.553,65.967,65.967,0,0,0,5.755,3.995.575.575,0,0,0,.793-.793A65.976,65.976,0,0,0,211.972,244.722Z",
    transform: "translate(-201.926 -201.959)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoOperationLimits);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_operation_limits.dd3efa8c1644c2002cedbb4dc8941482.svg";